module.exports = {"version":"5.0.11"}


//////////////////
// WEBPACK FOOTER
// ./version.json
// module id = 366
// module chunks = 1